<!-- 相册图片详情 -->
<template>
  <div class="photo-page">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1"><template v-if="photoAjaxObj.title">相册：{{photoAjaxObj.title}}
</template>

</div>
      </el-col>
      <el-col class="clear" :span="12">
        <el-upload
          class="avatar-uploader rt"
          action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS"
          :limit="9"
          :show-file-list="false"
          :on-exceed="handleExceed"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          multiple>
          <span  class="rt creatPhotoBtn" >
            <i  class="el-icon-plus avatar-uploader-icon el-border"></i>上传照片
          </span>
        </el-upload>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <div v-if="myPhoneList.length == 0" :span="8">
        <empty :acceptEmptyData="acceptEmptyData"></empty>
        <p style="text-align:center;margin: 35px 0"><el-upload
          class="avatar-uploader  "
          action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS"
          :limit="9"
          :show-file-list="false"
          :on-exceed="handleExceed"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          multiple>
          <span  class="rt creatPhotoBtn"  >
            <i  class="el-icon-plus avatar-uploader-icon el-border"></i>上传照片
          </span>
        </el-upload></p>
      </div>
      <el-col v-if="myPhoneList.length>0" :span="8" class="grid-img" v-for="(item,index) in myPhoneList" :key="index">
        <div  @click="showImage(item)">
          <div class="grid_img_out pos_rel clear">
            <img :src="item.photoImg ? item.photoImg : '/static/images/phone.jpeg'" alt="">
            <div class="pos_abs grid-icon-area">
              <span class="iconfont icon-shanchu2" @click.stop="editPhoto(item,'del')"></span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      title="图片预览"
      :visible.sync="dialogVisible"
      width="60%">
      <img :src="showImageInfor" width="100%" height="400" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import {
    insertUserPhotoBookMapping,
    selectUserPhotoBookByCode,
    deletePhotoBookMapping
  } from "api/apis";
  import photo from '../../components/homeCommon/photo'
  import empty from '../../components/common/empty'
  import $ from "jquery";
  export default {
    components: {
      photo,
      empty
    },
    data() {
      return {
        acceptEmptyData: {
          from: 'showImageInfor',
          msg: '暂无照片，可先上传哦～'
        },
        showImageInfor: '', //弹框展示
        dialogVisible: false,
        photoInfor: 'photoInfor',
        imgHead: {
          uid: localStorage.getItem("pbw_user_pc_uid"),
          token: localStorage.getItem("pbw_user_pc_token"),
        },
        user_code: localStorage.getItem("pbw_user_pc_uid"),
        loginKey: localStorage.getItem("pbw_user_pc_loginKey"),
        secretKey: localStorage.getItem("pbw_user_pc_secretKey"),
        myPhoneList: [],
        dialogFormVisible: false,
        form: {},
        showUpdateBtn: false,
        updatePhotoObj: {},
        imageUrl: '',
        fileList: [],
        photoAjaxObj: {},
      }
    },
    methods: {
      showImage(item) {
        console.log(item.photoImg, "图片")
        this.dialogVisible = true
        this.showImageInfor = item.photoImg
      },
      handleExceed(files, fileList) { //限制图片上传几个
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleAvatarSuccess(res, file, fileList) { //图片上传成功
        console.log(fileList, "回传成功")
        this.fileList = fileList
        this.addPhoto(fileList)
      },
      beforeAvatarUpload(file) {
        // 上传格式判断
        if (!/.(jpg|jpeg|png|bmp|JPG|JPEG|PNG|BPM)$/.test(file.name)) {
          this.$message.error('文件格式只能是jpeg、jpg、PNG、bmp中的一种!')
          return false
        }
        if (file.size > 100 * 1024 * 1024) {
          this.$message.error('文件大小超过限制')
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '上传中～',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 1500);
      },
      editPhoto(data, state) { //编辑图片
        console.log(data, "kkkkkkkkk")
        if (state == 'del') {
          console.log(data, "jjjj")
          this.$confirm('确认要删除该照片吗？')
            .then(_ => {
              deletePhotoBookMapping({
                title: data.code
              }).then((res) => {
                if (res.code == '000000') {
                  this.$message.success('删除成功了哦！')
                  this.getPhotoList()
                } else {
                  this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
                }
              })
            })
            .catch(_ => {});
        }
      },
      addPhoto(fileList) { //新增图片
        this.form.code = this.$route.query.code
        let arr = []
        console.log(fileList, "555555555")
        // for (let item of fileList) {
        //   console.log(item)
        //   arr.push(item.response.data.ossFileName)
        // }
        this.form.indexImg = fileList[fileList.length - 1].response.data.ossFileName
        insertUserPhotoBookMapping(this.form).then((res) => {
          if (res.code == '000000') {
            this.dialogFormVisible = false
            this.$message.success('图片上传成功！')
            this.getPhotoList()
          } else {
            this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
          }
        })
      },
      // updatePhoto () {
      //   console.log(this.updatePhotoObj,"更新")
      //   this.form.code = this.updatePhotoObj.code
      //   photoBook_updateUserPhotoBook(this.form).then((res) => {
      //     if (res.repCode == '000000') {
      //       this.dialogFormVisible = false
      //       this.$message.success('相册修改成功！')
      //
      //       setTimeout(()=>{
      //         this.getPhotoList()
      //       },300)
      //
      //     } else {
      //       this.$message.warning(res.repMsg ? res.repMsg : '数据加载中，请稍后')
      //     }
      //   })
      // },
      getPhotoList() {
        selectUserPhotoBookByCode({
          code: this.$route.query.code
        }).then((res) => {
          if (res.code == '000000') {
            this.myPhoneList = res.data.bookMapping
            this.photoAjaxObj = res.data
          } else {
            this.$message.warning(res.msg ? res.repMsg : '数据加载中，请稍后')
          }
        })
      },
    },
    mounted() {
      this.getPhotoList()
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  @import '../../scss/demo.scss';
  .photo-page .dashed {
    border-bottom: 1px dashed #F1F1F1;
    padding-bottom: 20px;
    margin-bottom: 25px;
  }
  .photo-page .title1 {
    font-size: 18px;
    color: #333;
  }
  .photo-page .title1::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 27px;
    border-radius: 5px;
    vertical-align: bottom;
    background-color: #F16202;
    margin-right: 20px;
  }
  .photo-page .title2,
  .photo-page .title2 em {
    text-align: right;
    font-size: 14px;
    color: #959595;
    line-height: 27px;
  }
  .photo-page .repeatable {
    padding-bottom: 20px;
  }
  .photo-page .repeatable .name {
    font-size: 14px;
    text-align: right;
    line-height: 40px;
  }
  /*相册*/
  .creatPhotoBtn {
    color: #f60;
    border: 1px solid #f60;
    font-size: 16px;
    padding: 2px 16px;
    border-radius: 50px;
    cursor: pointer;
    &:hover {
      background: #f60;
      color: #fff;
    }
  }
  .grid-img-area {
    position: relative;
  }
  .grid-icon-area {
    position: absolute;
    top: -4px;
    right: -10px;
    span {
      font-size: 16px;
      padding: 6px;
      border-radius: 50px;
      margin: 0 5px;
      color: #fff;
    }
    .icon-fabu {
      background: #f4b726;
    }
    .icon-shanchu2 {
      background: #f60;
    }
  }
  /*相册区域*/
  .grid-img {
    width: 30%;
    border-radius: 5px;
    box-shadow: 2px 4px 8px 4px rgba(197, 197, 197, 0.3);
    margin: 0px 30px 20px 0px;
    padding: 15px 14px;
  }
  .grid_content {
    padding-top: 8px;
    font-size: 14px;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    cursor: pointer;
  }
  .grid_img_out {
    height: 176px;
    img {
      width: 100%;
      height: 176px;
    }
  }
  .grid-img:nth-child(3n+0) {
    margin-right: 0px;
  }
  .tip_content {
    color: #fff;
    padding: 2px 8px;
    background: rgba(244, 183, 38, 0.8);
    right: 0px;
    bottom: 0px;
    border-top-left-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/showImageInfor.vue